import LanguageContext from '../../../../shared/components/utils/context/languageContext';
import LanguageText from '../../atoms/text/language';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import closeMenu from '../../../../shared/actions/menu/closeMenu';
import useList from '../../../../shared/components/utils/hooks/useList';
import { LanguageItemProps as Props } from '../../../../shared/types/props/language';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useEffect } from 'react';

function LanguageItem({ item, index }: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { displayLanguage, setLanguage } = useContext(LanguageContext);
  const { listIndex, focused } = useList(index);
  const text = TranslationManager.values[item as 'es' | 'en' | 'ca'];

  useEffect(() => {
    focused && index === listIndex && displayLanguage && displayLanguage(item);
  }, [focused, index, listIndex]);

  return (
    <LanguageText
      id={'languageText'}
      animation={{ transition: 'transform 0.15s' }}
      focused={focused && index === listIndex && !enabled}
      onClick={() => setLanguage(item)}
      onMouseEnter={() => {
        displayLanguage && displayLanguage(item);
        closeMenu();
      }}
    >
      {text}
    </LanguageText>
  );
}

export default LanguageItem;
